// extracted by mini-css-extract-plugin
module.exports = {"innerShadow":"CartSidebar_innerShadow__q_3FR","customScrollBar":"CartSidebar_customScrollBar__JWru_","sidebarTransition":"CartSidebar_sidebarTransition__Qw9Je"};